var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDating(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26.871,
    height: 27.02,
    viewBox: "0 0 26.871 27.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.859,
    y1: 0.901,
    x2: 0.06,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#40eefe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b402f6"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_9",
    "data-name": "Union 9",
    d: "M19272.854,25.94a1.4,1.4,0,0,1-.8-.937,42.434,42.434,0,0,1-.674-6.994,20.649,20.649,0,0,0,2.689,1.887h.137a20.928,20.928,0,0,0,.4,3.624,20.379,20.379,0,0,0,5.246.677,15.065,15.065,0,0,0,5.1-1.074,9.455,9.455,0,0,0,3.9-2.557,5.152,5.152,0,0,0,0-6.858,3.8,3.8,0,0,0-2.826-1.34,1.245,1.245,0,0,1-1.346-1.21,4.979,4.979,0,0,0-1.34-3.09,4.464,4.464,0,0,0-6.324,0,11.138,11.138,0,0,0-2.551,5.374,16.885,16.885,0,0,1-2.154-2.154,12.849,12.849,0,0,1,2.83-5.107,7.344,7.344,0,0,1,5.1-2.147,7.469,7.469,0,0,1,5.246,2.284,7.727,7.727,0,0,1,1.885,3.761,6.247,6.247,0,0,1,3.494,2.017,7.863,7.863,0,0,1-.137,10.625,14.9,14.9,0,0,1-11.021,4.3A24.31,24.31,0,0,1,19272.854,25.94Zm1.881-7.254c-.4-.273-8.738-5.381-8.738-12.5A6.255,6.255,0,0,1,19272.184,0a5.334,5.334,0,0,1,3.227.943,5.6,5.6,0,0,1,3.227-.943,6.007,6.007,0,0,1,5.643,3.761,8.228,8.228,0,0,0-4.035-1.074h-1.607a3.462,3.462,0,0,0-2.42.943,1.155,1.155,0,0,1-1.75,0,2.946,2.946,0,0,0-2.283-.943,3.555,3.555,0,0,0-3.494,3.494c0,4.574,4.971,8.471,6.721,9.681,1.477-.943,5.244-3.494,6.318-7.391a2.974,2.974,0,0,1,.668.534,3.24,3.24,0,0,1,.945,2.284v.4a19,19,0,0,1-7.4,6.994.819.819,0,0,1-.533.13A1.051,1.051,0,0,1,19274.734,18.686Z",
    transform: "translate(-19265.996)",
    fill: "url(#linear-gradient)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDating);
export default __webpack_public_path__ + "static/media/dating.fa43f40f1f8c0b646c0af395f6117dbc.svg";
export { ForwardRef as ReactComponent };